import { useState } from 'react';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

import SelectMobileValueMode from 'hb-builder/components/BuilderComponents/single/Headline/HeadlineSettings/HeadlineMobile/SelectMobileValueMode';
import {
  MOBILE_VALUE_MODES,
  generateResponsiveValues,
} from 'hb-builder/components/BuilderComponents/single/Headline/utils/settings';
import NumberSetting from 'hb-builder/components/common/SettingsLibrary/CommonSettings/NumberSetting';
import type {
  ComponentSettingsTab,
  OnChangeSettingsArgs,
} from 'hb-builder/types/settings';
import { type HeadlineItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/headlineItemAttributes';

const HeadlineMobile = (
  props: ComponentSettingsTab<HeadlineItemAttributes>,
) => {
  const { item, onChange } = props;
  const [mobileValueMode, setMobileValueMode] = useState(
    item.attributes?.isCustomMobileValue
      ? MOBILE_VALUE_MODES.CUSTOM
      : MOBILE_VALUE_MODES.AUTO,
  );

  const handleChangeFontSizeLineHeight = ({
    id,
    settingKey,
    value,
  }: OnChangeSettingsArgs) => {
    const key = settingKey?.includes('textFontSize')
      ? 'headlineFontSize'
      : 'headlineLineHeight';
    const breakpointsValue = (item.attributes as HeadlineItemAttributes)[key];

    onChange({
      id,
      settingKey: `attributes.${key}`,
      value: generateResponsiveValues({
        s: value,
        xl: breakpointsValue.xl,
      }),
    });
  };

  const customSettingProps = {
    ...props,
    onChange: handleChangeFontSizeLineHeight,
  };

  return (
    <Wrapper p={5}>
      <SelectMobileValueMode
        {...props}
        mobileValueMode={mobileValueMode}
        setMobileValueMode={setMobileValueMode}
      />
      <NumberSetting
        disabled={mobileValueMode === MOBILE_VALUE_MODES.AUTO}
        settingKey="textFontSize"
        title={__('Font size')}
        {...customSettingProps}
      />
      <NumberSetting
        disabled={mobileValueMode === MOBILE_VALUE_MODES.AUTO}
        settingKey="textLineHeight"
        title={__('Line height')}
        {...customSettingProps}
      />
    </Wrapper>
  );
};

export default HeadlineMobile;

const Wrapper = styled(Box).attrs(() => ({
  flexDirection: 'column',
  width: '100%',
}))``;
